import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import dashboard from 'locales/en/dashboard.json';
import common from 'locales/en/common.json';

const resources = {
  en: { dashboard, common },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  ns: ['dashboard', 'common'],
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
});
